(function () {
    document.querySelectorAll('[data-appbar]').forEach(bar => {
        const openBtn = bar.querySelector('[data-appbar-search-open]');
        const closeBtn = bar.querySelector('[data-appbar-search-close]');
        const field = bar.querySelector('.appbar__search input');

        openBtn?.addEventListener('click', () => {
            bar.classList.add('appbar--searching');
            field?.focus();
        });
        closeBtn?.addEventListener('click', () => {
            bar.classList.remove('appbar--searching');
            field?.blur();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') bar.classList.remove('appbar--searching');
        });
    });
})();
